<template>
	<div
		class="app-favorite-link-item ps-4"
	>
		<v-hover
			v-slot="{ isHovering, props: hoverProps }"
			:open-delay="100"
		>
			<div
				v-bind="hoverProps"
				:class="{ 'on-hover': isHovering || isActiveMenu }"
				class="link-item-content"
			>
				<ao-icon
					iconName="dragNDrop"
					class="draggable-handler text-textSecondary4"
				/>
				<v-list-item
					variant="flat"
					class="rounded mb-2 px-4"
					density="compact"
					exact
					active-color="primary"
					@click="onClickLinkItem(link, $event)"
				>
					<template v-slot:title>
						<span class="text-caption">{{ link.title }}</span>
					</template>
					<template v-slot:subtitle>
						<span class="text-caption">{{ link.subtitle }}</span>
					</template>
				</v-list-item>

				<v-menu
					v-model="isActiveMenu"
					:close-on-content-click="false"
				>
					<template v-slot:activator="{ props }">
						<ao-icon-btn
							v-bind="props"
							iconName="dotsHorizontal"
							variant="text"
							size="small"
							color="primary"
							class="menu-icon"
						/>
					</template>
					<v-list>
						<v-menu
							v-model="isActiveFavoriteLinkForm"
							location="right"
							:close-on-content-click="false"
						>
							<template v-slot:activator="{ props }">
								<v-list-item
									v-bind="props"
									value="change"
									density="compact"
									class="px-2 mx-2 ao-p2-regular d-flex align-center rounded"
									active-color="primary"
									height="24"
									max-height="24"
									min-height="24"
								>
									<ao-icon
										class="mr-2"
										iconName="pen"
									/>
									<span>{{ $t('Edit') }}</span>
								</v-list-item>
							</template>
							<FavoriteLinkForm
								:currentState="link"
								:currentGroupKey="currentGroupKey"
								:hideGroupSelect="true"
								:groups="groups"
								@saveLink="onSaveLink"
								@cancel="isActiveFavoriteLinkForm = false"
							/>
						</v-menu>
						<v-list-item
							value="delete"
							density="compact"
							class="px-2 mx-2 rounded d-flex align-center ao-p2-regular mt-1"
							active-color="primary"
							height="24"
							max-height="24"
							min-height="24"
							@click="emit('delete', {
								groupKey: currentGroupKey,
								linkKey: link.key,
								title: link.title,
							})"
						>
							<ao-icon
								class="mr-2"
								iconName="delete"
							/>
							<span>{{ $t('Delete link') }}</span>
						</v-list-item>
					</v-list>
				</v-menu>
			</div>
		</v-hover>
	</div>
</template>

<script setup>
import { ref } from 'vue'

import FavoriteLinkForm from '@/components/favorites/FavoriteLinkForm.vue'

import useRouts from '@/composables/useRouts'

const props = defineProps({
	link: {
		type: Object,
		required: true,
	},

	groups: {
		type: Array,
		default: () => [],
	},

	currentGroupKey: {
		type: String,
	},
})

const emit = defineEmits({
	update: null,
	delete: null,
})

const {
	route,
	router,
} = useRouts()

const isActiveMenu = ref(false)
const isActiveFavoriteLinkForm = ref(false)

const onClickLinkItem = (link, event) => {
	if (link.route.name === route.name) {
		const routerData = router.resolve(link.route)
		if (event.ctrlKey || event.metaKey) {
			window.open(routerData.href, '_blank')
		} else {
			window.location.href = routerData.href
		}
	} else {
		router.push(link.route)
	}
}

const onSaveLink = (payload) => {
	// console.log('save link', payload, props.currentGroupKey, props.link.key)
	emit('update', {
		groupKey: props.currentGroupKey,
		linkKey: props.link.key,
		payload: {
			title: payload.title,
			subtitle: payload.subtitle,
		},
	})
}
</script>

<style lang="scss">
.app-favorite-link-item {
	position: relative;
	overflow: hidden;

	.draggable-handler {
		position: absolute;
		z-index: 1;
		top: 50%;
		left: 0;
		opacity: 0;
		transform: translateY(-50%);
		transition: opacity 0.3s ease-in-out;
	}

	.menu-icon {
		position: absolute;
		top: 50%;
		right: 0.5rem;
		transform: translate(34px, -50%);
		transition: transform 0.3s ease-in-out;
	}

	&:hover {
		.draggable-handler {
			opacity: 1;
		}
	}

	.link-item-content {

		&.on-hover {
			.menu-icon {
				transform: translate(0, -50%);
			}
		}

	}


}
</style>
